import Results from "client/common/components/results/Results";
import { ProductListSource } from "client/analytics/types";
import ProductCardResults from "client/products/components/ProductCardResults";

import { useCollectionSearch } from "../hooks";
import { StorefrontCollection } from "../types";

import styles from "../styles/CollectionResults.module.less";

type CollectionResultsProps = {
  collection: StorefrontCollection;
  /** Which surface is reporting the list. */
  listSource: ProductListSource;
};

const CollectionResults = ({ collection, listSource }: CollectionResultsProps) => {
  const {
    products,
    latencyMs,
    isLoading,
    isRefetching,
    isPlaceholderData,
    error,
    selectedFilters,
    sort,
    applyFilters,
    applySort,
    goToPage,
  } = useCollectionSearch(collection);

  if (isLoading) {
    return (
      <div className={styles.results}>
        <Results.Loading description="Loading products" />
      </div>
    );
  }
  if (error || !products) {
    return (
      <div className={styles.results}>
        <Results.FetchError error={error} entityName="product" />
      </div>
    );
  }

  return (
    <div className={styles.results}>
      <ProductCardResults
        products={products}
        isRefetching={isRefetching}
        isStale={isPlaceholderData}
        filters={selectedFilters}
        onFiltersChange={applyFilters}
        onPageChange={goToPage}
        listSource={listSource}
        listContext={{ collectionSlug: collection.slug, latencyMs }}
        entityName="result"
        empty={{ header: "No products found", filteredDescription: "Try removing a filter." }}
        showFilters={collection.show_filters}
        sort={sort}
        onSortChange={applySort}
      />
    </div>
  );
};

export default CollectionResults;
